module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a1878b1b94f69b677ce8578b187a7416.png";